module.exports = __webpack_public_path__ + "step-3-desktop.8a199474e713d2bde2a6.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/payment-catalog/step-3-desktop.png
// module id = ../../../../../src/assets/payment-catalog/step-3-desktop.png
// module chunks = styles